import React                  from 'react';
import classnames             from 'classnames';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';

const PartInfo = (props) => {
  return (
    <div className="part-info">
      <div className="mpn">
        {props.mpn}
      </div>
      <div className="manufacturer">
        {props.manufacturer}
      </div>
      <div className="reference-designator">
        {props.reference_designator}
      </div>
    </div>
  )
}

export default PartInfo;